<template>
  <div class="user-wrapper">
    <div class="content-box" style="height: 50px;">

      <div class='searchDiv' @click="toSearch">
        <div id="searchButtonId" class="searchButton" @mouseover="mouseOver" @mouseleave="mouseLeave" >
          <pt-icon v-if='searchFlag'  style="font-size: 15px;"  type="icon-quanjusousuo"/>
          <pt-icon v-else style="font-size: 15px;"  type="icon-quanjusousuo-hei"/>
          <span style='margin-left: 5px;font-size: 14px;font-weight: 400;'>{{$t('router.manager.statistics.search')}}</span>
        </div>
      </div>

      <div style="display: inline-block;  cursor: pointer;  width: 89px;text-align: right;position: relative;" @click="openPdf">
        <img src="@/assets/use.png" alt="" style="width: 51px;height: 20px;position: absolute;left: 5px;top: 15px;">
        <pt-icon class="action" style="font-size: 17px;" title-position="bottom" type="icon-shiyongzhinan"/>
      </div>

      <pt-icon class="action" :title="$t('router.manager.statistics.exportRecord')" title-position="bottom" @click.native="openFiles" type="icon-xiazai4"/>
      <pt-icon class="action" :title="$t('baseVO.collection')" title-position="bottom" @click.native="openCollection" type="icon-xingzhuang3"/>



      <span @click="openMessageList" style="cursor: pointer">
        <a-badge :count="messageCount"  class="messageCount" :overflowCount="10" v-if="messageCount > 0">
          <pt-icon class="action" :title="$t('baseVO.message')"  type="icon-xiaoxitixing1"/>
        </a-badge>
        <pt-icon  v-else class="action" :title="$t('baseVO.message')"  type="icon-xiaoxitixing1"/>
      </span>

      <!--<lang-select />-->
<!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <pt-icon type="icon-shezhi3"></pt-icon>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-sub-menu :title="$t('user.modal.language')" key="0" @click="SwitchLang">
            <a-menu-item key="zh-CN">
              <a rel="noopener noreferrer">
                <span role="img" aria-label="简体中文">🇨🇳</span> 简体中文
              </a>
            </a-menu-item>
            <a-menu-item key="zh-TW">
              <a rel="noopener noreferrer">
                <span role="img" aria-label="繁体中文">🇭🇰</span> 繁体中文
              </a>
            </a-menu-item>
            <a-menu-item key="en-US">
              <a rel="noopener noreferrer">
                <span role="img" aria-label="English">🇬🇧</span> English
              </a>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="1" @click="updatePassword">
            <span>{{$t('user.modal.resetPassword')}}</span>
          </a-menu-item>
          <a-menu-item key="4" @click="updateUserInfoVisible = true">
            <span>{{$t('user.modal.userInfo')}}</span>
          </a-menu-item>
          <a-menu-item key="2" @click="openHomePage">
            <span>{{$t('user.modal.homePageSet')}}</span>
          </a-menu-item>
          <a-menu-item key="3" @click="versionUpdateVisible = true">
            <span>{{$t('baseVO.versionUpdate')}}</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <pt-icon class="action" :title="$t('baseVO.logout')" title-position="bottom" @click.native="handleLogout" type="icon-tuichu"/>
    </div>



    <div v-if='searchPanel'>
      <search-overall @cancel="cancelSearch"></search-overall>
    </div>



    <pt-modal :title="$t('user.modal.resetPassword')" :width="500" :visible="modal.visible" :loading="modal.loading" @ok="handleOk"
                  @cancel="handleCancel">
      <div slot="content">
        <update-password ref="addModalForm" ></update-password>
      </div>
    </pt-modal>
    <pt-modal :title="$t('user.modal.homePageSet')" :width="800" :visible="homePageModal.visible" :loading="homePageModal.loading" @ok="homePageOk" @cancel="homePageCancel">
      <div slot="content">
        <home-page-set ref="homePageModal" @saveSuccess="saveSuccess" @error="submitError"></home-page-set>
      </div>
    </pt-modal>
    <pt-drawer :visible="drawer.visible" :title="$t('router.manager.statistics.exportRecord')" :width="800" @close="drawer.visible = false">
      <div slot="content">
        <file-list></file-list>
      </div>
    </pt-drawer>
    <pt-drawer :visible="versionUpdateVisible" :title="$t('baseVO.versionUpdate')" :width="800" @close="versionUpdateVisible = false">
      <div slot="content">
        <update-info-list></update-info-list>
      </div>
    </pt-drawer>
    <pt-drawer :visible="updateUserInfoVisible" :title="'个人资料'" :width="950" @close="updateUserInfoVisible = false">
      <div slot="content">
        <user-info></user-info>
      </div>
    </pt-drawer>
  </div>
</template>

<script>
import homePageSet from '@/components/tools/HomePageSet'
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters,mapState } from 'vuex'
import LangSelect from '@/components/tools/LangSelect'
import updatePassword  from './updatePassword'
import Api from '@/api/sys/account'
import { mixin as langMixin } from '@/store/i18n-mixin'
import messageApi from '@/api/message/message'
import fileList from './file'
import updateInfoList from '@/components/tools/updateInfoList'
import UserInfo from './user-detail'
import searchOverall from '@/components/searchOverall/index'
export default {
  name: 'UserMenu',
  mixins: [langMixin],
  components: {
    searchOverall,
    LangSelect,
    NoticeIcon,
    updatePassword,
    homePageSet,
    fileList,
    updateInfoList,
    UserInfo
  },
  data(){
    return {
      searchPanel:false,
      searchFlag:true,
      messageCount:0,
      modal:{
        loading:false,
        visible:false,
      },
      homePageModal:{
        loading:false,
        visible:false,
      },
      drawer:{
        visible:false,
      },
      versionUpdateVisible:false,
      updateUserInfoVisible:false,
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar']),
    ...mapState({
      userInfo: state => state.user.info
    }),
  },
  watch:{
    $route(to,from){ //监听路由改变去重新刷新消息的数量
      if(from.path == '/message'){
        this.$bus.$emit('updateReadStatus');
      }
      this.getMessageConnt();
    }
  },
  mounted(){
    this.$bus.$on('flushMessageCount',()=>{
      this.getMessageConnt();
    })
    this.getMessageConnt();
  },
  methods: {

    mouseOver(){
      document.getElementById('searchButtonId').className = 'searchButtonOver'
      this.searchFlag = false
    },
    mouseLeave(){
      document.getElementById('searchButtonId').className = 'searchButton'
      this.searchFlag = true
    },

    openPdf(){
      window.open("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/BMS%E5%92%A8%E8%AF%A2%E9%A1%BE%E9%97%AE%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf",'_target')
    },

    toSearch() {
      this.$router.push({path:'/searchOverall'})
    },




    openFiles(){
      this.drawer.visible = true
    },
    getMessageConnt(){
      // let userId = this.userInfo.accountDO.id;
      messageApi.getUnReadCount().then(res=>{
        if(res.code == 1){
          this.messageCount = res.data;
        }else{

        }
      })
    },
    SwitchLang (row) {
      this.setLang(row.key)
      setTimeout(()=>{
        // window.location.reload()
      },500)
    },
    ...mapActions(['Logout']),
    handleLogout () {
      this.$ptConfirm({
        title: this.$t('user.modal.tipTitle'),
        content: this.$t('user.modal.logoutTip'),
        onOk: () => {
          return this.Logout({}).then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 16)
          }).catch(err => {

          })
        },
        onCancel () {
        }
      })
    },
    saveSuccess(){
      this.homePageCancel();
    },
    submitError(){
      this.homePageModal.loading = false;
    },
    cancelSearch(){
      this.searchPanel = false
    },


    handleCancel(){
      this.modal.visible = false
      this.modal.loading = false
    },
    homePageCancel(){
      this.homePageModal.visible = false;
      this.homePageModal.loading = false;
    },
    openHomePage(){
      this.homePageModal.visible = true;
    },
    updatePassword(){
      this.modal.visible = true
    },
    homePageOk(){
      this.homePageModal.loading = true;
      this.$refs.homePageModal.submit();
    },
    handleOk() {
        this.modal.loading = true
        //保存
        this.$refs.addModalForm.getData().then((datas) => {
            this.save(datas)
        }).catch(()=>{
          this.modal.loading = false
        })
    },
    save(datas){
        Api.updatePassword(datas).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.handleCancel()
            //修改密码,重新登录
            this.$warning({
              title:this.$t('user.loginTips.title'),
              content:this.$t('user.loginTips.content'),
              onOk:()=>{
                this.Logout({}).then(() => {
                  setTimeout(() => {
                    window.location.reload()
                  }, 16)
                }).catch(err => {

                })
              }
            })

          }else{
            this.modal.loading = false
          }
       })
    },
    openMessageList(){//跳转到消息列表
      this.$router.push({path:'/message'});
    },
    openCollection(){
      this.$router.push({path:'/collection'});
    }
  }
}
</script>
<style lang="less" scoped>


.searchDiv{
  display: inline-block;
  cursor: pointer;
  text-align: right;
  position: relative;
  margin-right: 40px;
}

.searchButton{
  height: 30px;
  width: 100px;
  background: #858484;
  border-radius: 20px;
  color: #FFFFFF;
  position: relative;
  bottom:5px;
  display: flex;
  align-items: center;
  justify-content: center
}

.searchButtonOver{
  height: 30px;
  width: 100px;
  background: #FFFFFF;
  color: #333333;
  border-radius: 20px;
  position: relative;
  bottom:5px;
  display: flex;
  align-items: center;
  justify-content: center
}





  .messageCount > .ant-badge-count, .ant-badge-dot, .ant-badge .ant-scroll-number-custom-component{
    position: absolute;
    top: 6px;
    right: 13px;
  }
  .messageCount > .ant-badge-count{
    z-index: auto;
    min-width: 18px;
    height: 18px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 6px;
    line-height: 18px;
    white-space: nowrap;
    text-align: center;
    background: #F5222D;
    border-radius: 9px;
    -webkit-box-shadow: 0 0 0 1px #fff;
    box-shadow: 0 0 0 0px #fff;
  }
</style>
